export default __webpack_public_path__ + "static/media/chevron_down.128e86eb.svg";